import React from 'react';
import { Container, Typography, Link, Box } from '@mui/material';

const CONTACT_EMAIL = 'info@suzmesayac.com'; // gerekirse değiştir

export default function Support() {
  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>Destek & İletişim</Typography>
      <Typography paragraph>
        Yardım almak, geri bildirim vermek veya bir sorun bildirmek için bize e-posta gönderebilirsiniz.
      </Typography>

      <Box sx={{ p: 2, border: '1px solid #e5e7eb', borderRadius: 2, mb: 3 }}>
        <Typography variant="subtitle1" gutterBottom>E-posta</Typography>
        <Link href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Link>
      </Box>

      <Typography variant="h6" gutterBottom>Sık Sorulanlar (öneri)</Typography>
      <Typography component="ul" sx={{ pl: 3 }}>
        <li>İlk sayaç okumasını nasıl eklerim?</li>
        <li>Fatura paylaştırma nasıl çalışır?</li>
        <li>Hesabımı nasıl silebilirim?</li>
      </Typography>
    </Container>
  );
}
